exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".network-banner{position:fixed;top:0;left:0;right:0;background-color:#ff6b6b;color:#fff;padding:12px;text-align:center;font-weight:600;z-index:9999}", ""]);

// exports
